import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import axios from "../../api/axios";
import Cookies from "universal-cookie";
const cookies = new Cookies(); 




function useSetStudent() {
    const [error, onError] = useState()
    const [success, onSuccess] = useState()
    const setDataToServer = useMutation((data) => setUsers(data), {
        onError: (err) => {
            onError(true)
        },
        onSuccess: () => {
            onSuccess(true)
        }
    })
    const setUsers = async (getFormData) => {
        let TOKEN = cookies.get("_pn_token");
        let fd = new FormData()
        for (var key in getFormData) {
            fd.append(key, getFormData[key]);
        }
        const response = await axios({
            method: "POST",
            data: fd,
            url: `/createStudent`,
            headers: { Authorization: TOKEN ? `Bearer ${TOKEN}` : '', }
        })
        return response.data
    }
    return { setDataToServer, error, onError, success, onSuccess }
}

export default useSetStudent